import rete from "./views/Rete";
import rete2 from "./views/Rete_2";
import about from "./views/About";
import login from "./views/Login";
import home from "./views/Home";
import firebase from "firebase";
const fb = require('./firebaseConfig.js')

import VueRouter from "vue-router";

const routes = [
  { path: "*", redirect: "/" },
  { path: "/", component: home },
  {
    path: "/tryme",
    component: rete2,
    meta: {
      requiresAuth: false,
      requiresEditor: false
    }
  },
  {
    path: "/editor",
    component: rete,
    meta: {
      requiresAuth: true,
      requiresEditor: true
    }
  },
  { path: "/about", component: about }
  // { path: "/login", component: login }
];

const router = new VueRouter({
 // mode: "history",
  routes
});

router.beforeEach(
  (to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      //   var isLoggedIn = localStorage.getItem('token') != null;

      const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
      const currentUser = firebase.auth().currentUser;
      if (requiresAuth && !currentUser) {
        next("/");
        alert("Please Sign In");
      } else if (requiresAuth && currentUser) {
        if (to.matched.some(record => record.meta.requiresEditor)) {
          fb.usersCollection.doc(currentUser.uid).get().then(res =>{

            if(res.data().editorEnabled){
              next();            
            }else{
              alert("Please Contact Pivot 3 To Enable Editor");
            }
          })

        } else {
          next();
        }
      }
    } else {
      next();
    }
  }

);

export default router;
